<template>
  <div class="mb-4">
    <validation-observer ref="formValidator" novalidate tag="form">
      <custom-callout border-color="green" class="mb-4" :has-toggle="false">
        <div class="mb-2">
          <div class="row">
            <div class="col">
              <icon-view
                icon="fas fa-check-circle"
                icon-background="#fff"
                icon-color="#2db782"
                icon-size="15px"
                title="Pago de Jornal"
              />
            </div>
          </div>
          <div class="row mt-2 ml-1">
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-date-picker
                  v-model="model.paymentDate"
                  custom-error-msg="Fecha es requerida."
                  :error="errors[0]"
                  label="Fecha:"
                  :max-date="new Date()"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
            </div>
            <div
              class="col d-flex justify-content-end align-items-end pr-4 pr-md-5 pr-sm-4 mt-3 mt-md-0 mt-sm-3"
            >
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger btn-cancel danger pl-4 pr-4 mr-3"
                @click="onCancelHandler"
              />
              <action-button
                i="fas fa-arrow-circle-right"
                text="Continuar"
                variant="success pl-4 pr-4"
                @click="onContinueHandler"
              />
            </div>
          </div>
        </div>
      </custom-callout>
    </validation-observer>
    <hr />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alertMixin from 'utils/mixins/alert.mixin';
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';

export default {
  name: 'PaymentJournalProcess',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    IconView,
    CustomDatePicker,
    ActionButton,
  },
  mixins: [alertMixin],
  data() {
    return {
      model: {
        paymentDate: null,
      },
    };
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onContinueHandler() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      this.$emit('on-continue', {
        paymentDate: new Date(this.model.paymentDate),
      });
    },
  },
};
</script>
